/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable sonarjs/no-all-duplicated-branches */
/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable react/require-default-props */
import { SmlsButton, SmlsListItem, SmlsLoadingLogo, SmlsSkeleton } from '@smiles/smiles-ui-kit-react';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Input } from 'reactstrap';
import { Button, Icon } from '..';
import { useAppSelector } from '../../hooks/useRedux';
import { capitalizeFirstLetter, mapToCssModules } from '../../utils';
import { RecentSearchesType } from '../../utils/localStorage';
import { IAutoCompleteSearch, ISearchHotelNearestTravel, ISearchHotelsResponse } from './types';

export type SearchOutput = {
  id: number;
  name: string;
  description: string;
  type: string;
};

export default function SmlsAutoCompleteSearch<T extends ISearchHotelsResponse>({
  ref,
  showCTABanner = false,
  mobile = false,
  id,
  textLabel,
  onFocusMobilePlaceholder = 'Digite seu país',
  onFocusDesktopPlaceholder,
  errorMessage = 'Error message',
  className = '',
  initialList = [],
  notFoundTitle = 'Não encontramos nenhum resultado.',
  notFoundSubtitle = 'Que tal tentar uma nova busca?',
  expandOnEnter = false,
  placeholder,
  disabled = false,
  value = 'teste',
  icon,
  forceError = false,
  forceFocus,
  inputId,
  notFoundSearchTextId,
  inputErrorId,
  loadingLogoId,
  onSearch = () => undefined,
  onSelectedItem = () => undefined,
  onValid = () => undefined,
  onMobileClose = () => undefined,
  onFocus,
  onBlur,
  onToggle = () => undefined,
  onNextStepCrossSell,
  runHandleInitialList,
  expansible,
  isCrossSell,
}: IAutoCompleteSearch<T>): React.ReactElement<IAutoCompleteSearch<T>> {
  const { t } = useTranslation();
  const userData = useAppSelector(({ user }) => user.member);
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const [isTyping, setIsTyping] = useState<boolean>(false);
  const [isFilled, setIsFilled] = useState<boolean>(false);
  const [innerValue, setInnerValue] = useState<string>(value);
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [isValidInput, setIsValidInput] = useState<boolean>(true);
  const [listOfItems, setListOfItems] = useState<SearchOutput[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSkeletonLoading, setIsSkeletonLoading] = useState<boolean>(false);
  const [dropdownList, setDropdownList] = useState<any[]>([]);
  // viagem próxima encontrada
  const [hasNearestTravel, _setHasNearestTravel] = useState<boolean>(true);

  const thisRef = useRef<HTMLUListElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const innerInputRef = useRef<HTMLInputElement>(null);
  const isNotFound = listOfItems.length === 0 && innerValue.length > 2 && !isValidInput;

  useEffect(() => {
    if (runHandleInitialList) {
      handleInitialList();
    }
  }, []);

  const toggle = () => {
    onToggle();
    setDropdownOpen((prevState) => !prevState);
  };

  const onMobileReturn = () => {
    onMobileClose();
    setDropdownOpen((prevState) => !prevState);
  };

  const onComponentFocus = useCallback(() => {
    if (onFocus) {
      onFocus();
    }
    setIsFocused(true);

    /* eslint-disable-next-line */
  }, [onFocusDesktopPlaceholder]);

  const disableOutline = useCallback(() => {
    if (onBlur) {
      onBlur();
    }
    setIsFocused(false);

    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [placeholder, onFocusDesktopPlaceholder]);

  const handleDebouncedValue = async () => {
    const hasValue = innerValue.length > 0;
    if (!hasValue || !isTyping || innerValue.length < 3) {
      setIsTyping(false);
      setIsLoading(false);
      setListOfItems([]);
      return;
    }
    try {
      const foundItems = await onSearch(innerValue);
      if (!foundItems) {
        throw new Error();
      }
      const hasResults = foundItems ? foundItems.length > 0 : false;

      setListOfItems(foundItems);

      setIsValidInput(hasResults);
      onValid(hasResults);
    } catch {
      setListOfItems([]);
    } finally {
      setIsFilled(hasValue);
      setIsTyping(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!innerValue.length) {
      return setIsLoading(false);
    }

    const debounceTimeout = setTimeout(handleDebouncedValue, 1000);

    return () => clearTimeout(debounceTimeout);

    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [innerValue]);

  useEffect(() => {
    setInnerValue(capitalizeFirstLetter(value));
    setIsValidInput(true);
  }, [value]);

  useEffect(() => {
    if (isTyping) {
      setDropdownOpen(true);
    }
  }, [isTyping]);

  useEffect(() => {
    if (forceFocus && innerInputRef) {
      setDropdownOpen(true);

      /* eslint-disable-next-line no-unused-expressions */
      innerInputRef.current?.focus();
    }
  }, [forceFocus, innerInputRef]);

  const handleOnChange = useCallback((event) => {
    const text = event.target.value;
    if (text.length > 2) {
      setIsLoading(true);
    }
    setIsTyping(true);
    setInnerValue(text);
    setListOfItems([]);
  }, []);

  const handleOnKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'ArrowDown' && thisRef.current) {
      const next = event.currentTarget.parentElement?.nextElementSibling?.children[0] as HTMLElement;
      if (next) {
        next.focus();
      }
    }

    if (event.key === 'ArrowUp' && thisRef.current) {
      const next = event.currentTarget.parentElement?.previousElementSibling?.children[0] as HTMLElement;
      if (next) {
        next.focus();
      } else {
        const inp = inputRef.current?.children[0] as HTMLElement;
        if (inp) {
          inp.focus();
        }
      }
    }
  };

  const handleInputKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'ArrowDown' && thisRef.current) {
      const next = thisRef.current.children[0].children[0] as HTMLElement;
      if (next) {
        next.focus();
      }
    }
    if (event.key === 'Escape' && dropdownOpen) {
      toggle();
    }
  };

  const handleInitialItemClick = useCallback(
    (item: ISearchHotelNearestTravel | RecentSearchesType) => {
      setInnerValue(capitalizeFirstLetter(item.destination.split(',')[0]));
      setIsLoading(true);
      setIsTyping(true);
      setIsValidInput(true);
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [innerValue, value],
  );

  const handleItemClick = useCallback(
    (item: SearchOutput) => {
      setInnerValue(capitalizeFirstLetter(item.name));
      onSelectedItem(item);
      setDropdownOpen(false);
      setListOfItems([]);
      onToggle();
    },
    [onSelectedItem],
  );

  const handleInitialList = () => {
    setIsSkeletonLoading(true);
    setTimeout(() => {
      setDropdownList(initialList);
      setIsSkeletonLoading(false);
    }, 2000);
  };

  const handleClear = () => {
    setInnerValue('');
    setListOfItems([]);
  };

  const renderCTAPanelBanner = (isMobile: boolean) => {
    return isMobile ? (
      <section className="panel-banner-wrapper-mobile">
        <div className="panel-banner-label-mobile">{t('home.searchPanel.mobileCTALabel')}</div>
        <button
          type="button"
          className="panel-banner-button-mobile"
          onClick={() => window.location.assign('https://www.smiles.com.br/descubra-seu-novo-destino')}
        >
          <div className="button-text-wrapper">
            <Icon icon="language" className="material-icons button-text-icon" />
            <span className="button-text">{t('home.searchPanel.CTAButton')}</span>
          </div>
          <Icon icon="chevron_right" className="material-icons button-icon" />
        </button>
      </section>
    ) : (
      <section className="panel-banner">
        <div className="panel-banner-text-wrapper">
          <span className="panel-banner-title">{t('home.searchPanel.CTALabel')}</span>
          <span className="panel-banner-subtitle">{t('home.searchPanel.CTADescription')}</span>
        </div>
        <div
          className="panel-banner-link"
          onClick={() => window.location.assign('https://www.smiles.com.br/descubra-seu-novo-destino')}
        >
          <Button className="panel-banner-button">{t('home.searchPanel.CTAButton')}</Button>
        </div>
      </section>
    );
  };

  return (
    <div
      className={mapToCssModules([
        'autocomplete-search',
        className,
        expandOnEnter ? 'expanded' : '',
        mobile && dropdownOpen ? 'dropdown-mobile' : 'input-group',
        disabled ? 'disabled' : '',
        isTyping ? 'typing' : '',
        isFilled && mobile ? 'filled' : '',
        isFocused ? 'input-outline' : '',
        !mobile && ((!isValidInput && !dropdownOpen) || (forceError && !dropdownOpen)) ? 'error' : '',
      ])}
    >
      {textLabel && (!mobile || (mobile && !dropdownOpen)) && <label htmlFor={textLabel}>{textLabel}</label>}

      <Dropdown id={id} isOpen={dropdownOpen} toggle={toggle}>
        <div className="dropdown-toggle" ref={inputRef}>
          {mobile && !dropdownOpen && icon}
          {mobile && dropdownOpen && (
            <Icon icon="chevron_right" className="material-icons mobile-return-icon" round onClick={onMobileReturn} />
          )}
          <Input
            className={mapToCssModules([mobile && dropdownOpen ? 'mobile-input' : ''])}
            value={innerValue}
            disabled={disabled}
            onChange={handleOnChange}
            placeholder={
              /* eslint-disable-next-line no-nested-ternary */
              mobile && dropdownOpen ? onFocusMobilePlaceholder : isFocused ? onFocusDesktopPlaceholder : placeholder
            }
            onFocus={onComponentFocus}
            onBlur={disableOutline}
            onKeyDown={handleInputKeyDown}
            autoComplete="false"
            id={inputId}
            innerRef={innerInputRef}
            onClick={() => {
              if (!disabled && !dropdownOpen) {
                handleInitialList();
                toggle();
              }
            }}
          />
          {dropdownOpen && innerValue.length > 0 && (
            <Icon icon="close" className="material-icons notranslate mobile-close-icon" round onClick={handleClear} />
          )}
        </div>
        <div>
          <ul className={`dropdown-menu expansible ${isLoading ? 'is-loading-dropdown' : ''}`} ref={thisRef}>
            {isLoading && (
              <div className={mapToCssModules([mobile ? 'dropdown-menu-loading-mobile' : 'dropdown-menu-loading'])}>
                <SmlsLoadingLogo id={loadingLogoId} />
              </div>
            )}
            {!isLoading && (
              <div className={mapToCssModules([mobile ? 'dropdown-search-list-mobile' : 'dropdown-search-list'])}>
                {showCTABanner && !isNotFound && listOfItems.length === 0 && renderCTAPanelBanner(mobile)}
                {(dropdownList || (userData && hasNearestTravel)) && innerValue === '' && (
                  <SmlsSkeleton
                    className="dropdown-skeleton"
                    ready={!isSkeletonLoading}
                    renderLoadingContent={() => {
                      return [
                        {
                          borderRadius: '1rem',
                          width: 160,
                          height: 12,
                          backgroundColor: '#E2E2E2',
                          marginBottom: 15,
                        },
                        {
                          borderRadius: '1rem',
                          width: 203,
                          height: 16,
                          backgroundColor: '#E2E2E2',
                          marginTop: 28,
                          marginBottom: 28,
                        },
                        {
                          borderRadius: '1rem',
                          width: 203,
                          height: 16,
                          backgroundColor: '#E2E2E2',
                          marginTop: 28,
                          marginBottom: 28,
                        },
                        {
                          borderRadius: '1rem',
                          width: 203,
                          height: 16,
                          backgroundColor: '#E2E2E2',
                          marginTop: 28,
                          marginBottom: 28,
                        },
                        /* eslint-disable-next-line react/jsx-key */
                      ].map((content) => <SmlsSkeleton.Content style={content} />);
                    }}
                  >
                    {/* Não será utilizado no MVP:
                      {userData && hasNearestTravel && !isNotFound && listOfItems.length === 0 && (
                        <section className="nearest-travel-wrapper">
                          <SmlsListItem
                            id="nearest-travel"
                            type="text"
                            item={loggedUserNearestTravel.destination}
                            caption={loggedUserNearestTravel.date.toString()}
                            label={loggedUserNearestTravel.destination}
                            onClick={() => handleInitialItemClick(loggedUserNearestTravel)}
                            icon={<Icon icon="place" className="material-icons" style={{ color: '#333333' }} />}
                            key={loggedUserNearestTravel.destination}
                          />
                          <span
                            className={mapToCssModules([mobile ? 'nearest-travel-badge-mobile' : 'nearest-travel-badge'])}
                          >
                            {t('smlsAutoCompleteSearch.nearestTravelBadge')}
                          </span>
                          <div className="nearest-travel-divider" />
                        </section>
                      )} */}
                    {(innerValue.length === 0 || (isValidInput && listOfItems.length === 0)) &&
                      initialList.map((suggestion) => (
                        <div className="dropdown-menu-initial-list" key={suggestion.label}>
                          {suggestion.items.length > 0 ? (
                            <>
                              <label id={suggestion.labelId}>{suggestion.label}</label>
                              {suggestion.items.map((item: RecentSearchesType) => (
                                <SmlsListItem
                                  type="text"
                                  item={capitalizeFirstLetter(item.destination)}
                                  icon={
                                    <Icon icon="schedule" className="material-icons" style={{ color: '#333333' }} />
                                  }
                                  key={`${suggestion.label}-${item.destination}`}
                                  onClick={() => handleInitialItemClick(item)}
                                  onKeyDown={handleOnKeyDown}
                                  expansible={expansible}
                                />
                              ))}
                            </>
                          ) : (
                            ''
                          )}
                        </div>
                      ))}
                  </SmlsSkeleton>
                )}
                {listOfItems.length > 0 &&
                  listOfItems.map((item) => (
                    <SmlsListItem
                      type="text"
                      resultText={undefined}
                      id={item.id.toString()}
                      item={capitalizeFirstLetter(item.name)}
                      label={item.description}
                      caption={item.description}
                      icon={<Icon className="material-icons smls-icon-city" icon={item.type} />}
                      key={item.id}
                      onClick={() => handleItemClick(item)}
                      onKeyDown={handleOnKeyDown}
                    />
                  ))}
                {mobile && isCrossSell && !!innerValue && !listOfItems.length && (
                  <div className="action-panel">
                    <SmlsButton text="Confirmar" className="button-confirm" onClick={onNextStepCrossSell} />
                  </div>
                )}
                {isNotFound && (
                  <div
                    className={mapToCssModules([mobile ? 'dropdown-menu-not-found-mobile' : 'dropdown-menu-not-found'])}
                    id={notFoundSearchTextId}
                  >
                    {notFoundTitle && <p>{notFoundTitle}</p>}
                    {notFoundSubtitle && <p>{notFoundSubtitle}</p>}
                  </div>
                )}
              </div>
            )}
          </ul>
        </div>
      </Dropdown>
      {!mobile && (!isValidInput || forceError) && !dropdownOpen && (
        <div className="input-error" id={inputErrorId}>
          <Icon icon="error_outline" className="material-icons notranslate" />
          <label htmlFor="input-text">{errorMessage}</label>
        </div>
      )}
    </div>
  );
}
